<template>
  <div
    class="md:w-11/12 w-full flex h-32 sm:h-auto flex-wrap mx-auto shadow-xl bg-white py-2 sm:px-2"
  >
    <div class="sm:flex-1 flex-initial w-full sm:order-1 order-2">
      <div class=" flex sm:ml-0 mx-auto sm:w-60 mt-2 px-5">
        <button
          @click="toggler('list')"
          v-bind:class="{
            'text-white bg-green-700': currentView === 'list',
            'text-green-700  bg-white': currentView !== 'list',
          }"
          class="flex-1 text-sm rounded rounded-r-none outline-none py-1 border text-green-700 border-green-700 hover:border-green-900 hover:bg-green-900 hover:text-white transition ease-in-out duration-500"
        >
          List
        </button>
        <button
          @click="toggler('map')"
          v-bind:class="{
            'text-white bg-green-700': currentView === 'map',
            'text-green-700  bg-white': currentView !== 'map',
          }"
          class="flex-1 text-sm rounded rounded-l-none outline-none py-1 border border-green-700 text-green-700 bg-white hover:border-green-900 hover:text-white hover:bg-green-900 transition ease-in-out duration-500"
        >
          Map
        </button>
      </div>
    </div>

    <div class="sm:flex-1 flex-initial relative w-full sm:order-2 order-1">
      <ul
        id="items"
        class="sm:float-right w-max  flex sm:mx-0 mx-auto 2xs:gap-x-6 xs:gap-x-10 xxs:gap-x-8 gap-x-3  sm:gap-x-8"
      >
        <li>
          <a class="text-gray-400 hover:text-lime" @click="updateSidenav(true)">
            <img src="/img/myle/svg/ic_date.svg" alt="" class="mx-auto mt-1 " />
            <p
              class="text-center selected font-light uppercase sm:text-2xs  text-3xs py-1"
            >
              {{
                currentSelectedFilters.date && currentSelectedFilters.date[0]
                  ? currentSelectedFilters.date[0].value.replace("_", " ")
                  : "This Month"
              }}
            </p>
          </a>
        </li>
        <li>
          <a class="text-gray-400 hover:text-lime" @click="updateSidenav(true)">
            <img
              src="/img/myle/svg/ic_category.svg"
              alt=""
              class="mx-auto mt-1 "
            />
            <p
              class="text-center selected font-light uppercase sm:text-2xs text-3xs py-1"
            >
              {{ currentSelectedFilters.category || "ALL" }}
            </p>
          </a>
        </li>
        <li>
          <a class="text-gray-400 hover:text-lime" @click="updateSidenav(true)">
            <img
              src="/img/myle/svg/ic_location.svg"
              alt=""
              class="mx-auto mt-1 "
            />
            <p
              class=" text-center selected font-light uppercase sm:text-2xs  text-3xs py-1"
            >
              {{ (currentSelectedFilters.radius > 0) ? currentSelectedFilters.radius : "1 " }} Miles
              {{ currentSelectedFilters.location.city }}
              {{
                currentSelectedFilters.location.country
                  ? "," + currentSelectedFilters.location.country
                  : ""
              }}
            </p>
          </a>
        </li>
        <li>
          <a class="text-gray-400 hover:text-lime" @click="updateSidenav(true)">
            <img src="/img/myle/svg/ic_sort.svg" alt="" class="mx-auto mt-1 " />
            <p
              class="  text-center selected font-light uppercase sm:text-2xs  text-3xs py-1"
            >
              {{ (currentSelectedFilters && currentSelectedFilters.sort && currentSelectedFilters.sort.length > 0) ? currentSelectedFilters.sort[0].value.replace("_", " ") : '' }}
            </p>
          </a>
        </li>
        <li class="  cursor-pointer transition duration-500 ease-in-out">
          <a
            id="search"
            class="text-gray-400 hover:text-lime"
            @click="tosearch = !tosearch"
          >
            <img
              src="/img/myle/svg/ic_search.svg"
              alt=""
              class="mx-auto mt-1 "
            />
            <p
              class=" text-center selected font-light uppercase sm:text-2xs  text-3xs py-1"
            >
              search
            </p>
          </a>
        </li>
      </ul>

      <ul
        id="search-box"
        class="right-0 top-0 w-full absolute bg-white sm:space-x-8"
        v-bind:class="{ hidden: !tosearch }"
      >
        <li
          class="w-full px-2 py-1 border flex border-lime  items-center rounded"
        >
          <i class="flex-none fas fa-search text-green-600"></i>
          <input
            type="text"
            v-model="searchfield"
            class=" flex-grow w-full outline-none text-sm text-gray-800 p-2 "
            placeholder="Search"
            v-on:keyup.enter="onSearch"
          />
          <i
            id="close-search"
            @click="cancel"
            class="flex-none fas fa-times cursor-pointer transition duration-500 ease-in-out  text-gray-400"
          ></i>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import router from "@/router";
import { mapMutations, mapState } from "vuex";

export default {
  name: "subnavbar",
  data() {
    return {
      searchfield: '',
      islist: true,
      tosearch: false,
    };
  },
  props: {},
  mounted() {
    this.tosearch = (this.startSearch != -1) ? true : false;
    this.searchfield = this.currentSelectedFilters.query ? this.currentSelectedFilters.query.join(' ') : '';
  },
  computed: {
    ...mapState("events", ["currentView", "currentSelectedFilters", "startSearch"]),
  },
  watch: {
    startSearch: function(v) {
      if (v == -1) {
        this.tosearch = false;
        this.searchfield = '';
      }
    }
  },
  methods: {
    ...mapMutations("events", ["updateCurrentView", "updateSidenav", "updateCurrentFilter", "makeSearch"]),
    toggler(v) {
      this.updateCurrentView(v);
    },
    cancel() {
      this.currentSelectedFilters.query = null;
      this.updateCurrentFilter({...this.currentSelectedFilters});
      this.tosearch = false;
      this.makeSearch({...this.currentSelectedFilters});
      this.searchfield = '';
    },
    onSearch() {
      if (this.searchfield && this.searchfield.trim()[0] === '#' && this.searchfield.trim().split(' ').length === 1) {
        this.currentSelectedFilters.query = this.searchfield;
      } else {
        this.currentSelectedFilters.query = this.searchfield.split(' ');
      }
      this.updateCurrentFilter(this.currentSelectedFilters);
      this.makeSearch(this.currentSelectedFilters);

      setTimeout(() => {
        this.makeSearch(0);
      })
    }
  },
};
</script>
<style scoped>
.bg-green-700 {
  background-color: rgb(4, 120, 87) !important;
}
</style>
